import { Link } from 'react-router-dom';
import { Project, ProjectCategory } from '../../types';
import { ui } from '../../data/ui';
import { ScrollReveal } from '../ui/ScrollReveal';
import './ProjectCard.css';

interface ProjectCardProps {
  project: Project;
  variant?: 'default' | 'featured' | 'compact';
  index?: number;
}

const categoryLabels: Record<ProjectCategory, string> = {
  AI: ui.projectCategories.AI,
  Mobile: ui.projectCategories.Mobile,
  Web: ui.projectCategories.Web,
  Backend: ui.projectCategories.Backend,
  'E-commerce': ui.projectCategories['E-commerce'],
  FinTech: ui.projectCategories.FinTech,
  Education: ui.projectCategories.Education,
  Enterprise: ui.projectCategories.Enterprise,
  Marketplace: ui.projectCategories.Marketplace,
};

export function ProjectCard({ project, variant = 'default', index = 0 }: ProjectCardProps) {
  const isFeatured = variant === 'featured';
  const isPlaceholder = (value: string) => value.startsWith('[');

  return (
    <ScrollReveal delay={index * 0.1}>
      <Link to={`/projects/${project.id}`} className={`project-card glass-card ${isFeatured ? 'project-card-featured' : ''}`}>
        <div className="project-card-image">
          {project.projectImage && !isPlaceholder(project.projectImage) ? (
            <img src={project.projectImage} alt={project.name} loading="lazy" />
          ) : (
            <div className="placeholder-image project-card-placeholder">
              {ui.projects.addScreenshot}
            </div>
          )}
          <div className="project-card-overlay">
            <span className="project-card-view">{ui.projects.viewProjectCard}</span>
          </div>
        </div>
        <div className="project-card-content">
          <div className="project-card-header">
            {project.companyLogo && (
              <div className="project-card-logo">
                {!isPlaceholder(project.companyLogo) ? (
                  <img src={project.companyLogo} alt={project.company || project.name} loading="lazy" />
                ) : (
                  <div className="placeholder-image project-logo-placeholder">{ui.projects.addLogo}</div>
                )}
              </div>
            )}
            <div className="project-card-meta">
              <span className="tag">{project.type}</span>
              {project.status && <span className="project-status">{project.status}</span>}
            </div>
          </div>
          <h3 className="project-card-title">{project.name}</h3>
          <p className="project-card-description">{project.shortDescription}</p>
          <div className="project-card-footer">
            <span className="project-card-role">{project.role}</span>
            <div className="project-card-tags">
              {project.categories.slice(0, 3).map((cat) => (
                <span key={cat} className="tag tag-secondary">{categoryLabels[cat]}</span>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </ScrollReveal>
  );
}
